import React, { useState } from "react";
import "./style.scss";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { useParams, useNavigate } from "react-router-dom";
import { PacmanLoader } from "react-spinners";

const OrderSuccess = () => {
  const { orderID } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="order-success-container-wrapper">
      <div className="order-success-container">
        <div className="order-success-con">
          <button className="checkmark-icon">
            <IoIosCheckmarkCircle />
          </button>

          <h5 style={{ color: "#5e2e86" }}>Bạn đã đặt hàng thành công</h5>
          <div>
            <h5>
              Vui lòng kiểm tra email hoặc bấm xem chi tiết đơn hàng để theo dõi
              đơn hàng của bạn!
            </h5>
          </div>

          <div className="order-actions">
            <button
              className="btn-order-details"
              onClick={() => navigate("/order-details", { state: { orderID } })}
            >
              Xem chi tiết đơn hàng
            </button>
            <button
              className="btn-continue-shopping"
              onClick={() => navigate("/")}
            >
              Tiếp tục mua sắm
            </button>
          </div>
        </div>
      </div>
      {isLoading && (
        <div className="modal">
          <div className="overlay_loading">
            <div className="modal-content_loading">
              <div className="d-flex">
                <PacmanLoader color="#5e2e86" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderSuccess;
